import { FEATURE_FLAGS } from '../../../../featureFlags';
import Bot from './Index.vue';
// Removed legacy CSML standalone routes; CSML is now handled via modal
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      name: 'agent_bots_settings',
      meta: {
        permissions: ['administrator'],
        showOnlyForSuperAdmin: true,
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'agent_bots',
          component: Bot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
        },
        // CSML editor is available inside `CSMLBotModal.vue`
      ],
    },
  ],
};
